import { render, staticRenderFns } from "./ShopRank.vue?vue&type=template&id=46795647&scoped=true&"
import script from "./ShopRank.vue?vue&type=script&lang=js&"
export * from "./ShopRank.vue?vue&type=script&lang=js&"
import style0 from "./ShopRank.vue?vue&type=style&index=0&id=46795647&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46795647",
  null
  
)

export default component.exports